// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GameProjectHeader_wrapper_1u1nQ","back":"GameProjectHeader_back_2j7hX","title":"GameProjectHeader_title_1Q_M-","projectIcon":"GameProjectHeader_projectIcon_34PVP"};